import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import PageLoading from "../../components/PageLoading.jsx";
import OurLocation from "./OurLocation.jsx";

import * as API from "../../api/api.js";

const BrowardCounty = ({settings}) => {
  const [loading, setLoading] = useState(false);
  const [broward, setBroward] = useState(null);

  useEffect(() => {
    setBrowardData();
  }, []);

  const setBrowardData = () => {
    setLoading(true);
    API.getDatas("city/broward")
      .then((res) => {
        const lIndex = res.data.findIndex(f => f.slug === 'broward');
        if (lIndex != -1) {
          setBroward(res.data[lIndex].locations);
          document.title = `Metro Traffic School - ${res.data[lIndex].name}`;
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  return (
    <>
      <section className="inner-page notranslate d-flex align-items-center justify-content-center">
        <div className="overlay"></div>
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xl-12">
              <nav aria-label="breadcrumb">
                <h4 className="main-heading text-capitalize text-center mb-0">
                  Locations
                </h4>
                <ol className="breadcrumb d-flex align-items-center justify-content-center">
                  <li className="breadcrumb-item">
                    <Link to="/" className="text-white">
                      Home
                    </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={""} className="text-white">
                      Locations
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Broward County
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section className="location-section section-padding">
        <div className="container">
          <div className="row">
            <OurLocation settings={settings} />
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 location-accordion">
              <div className="row">
                <div className="col-12">
                  <h3 className="text-white">Broward County</h3>{" "}
                  <div className="accordion-body col-12">
                    <div className="row">
                      {!loading &&
                        broward &&
                        broward.map((browardData, index) => (
                          <div
                            key={index}
                            className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-4 mb-md-5 d-flex justify-content-between flex-column"
                          >
                            <div className="address">
                              <h3>{browardData.title}</h3>
                              <div className="address-detail mb-3">
                                {browardData.address.split(',')[0]}<br/>
                                  {`${browardData.address.split(',')[1]}, ${browardData.address.split(',')[2]}`}
                                <br />
                                <a href="tel:954 422-5757">
                                  Phone: &nbsp;{browardData.phone}
                                  <br />
                                </a>
                                {browardData?.fax && (
                                  <p>Fax: &nbsp;{browardData.fax}</p>
                                )}
                                <br />
                              </div>
                            </div>
                            <div className="location-btns">
                              <Link
                                to="/contact-us"
                                className="btn contact-us-btn contact-btn mb-3"
                              >
                                <i className="fa-solid fa-envelope contact"></i>
                                Contact Us
                              </Link>
                              <Link
                                to={`/location/${browardData.slug}`}
                                className="btn contact-us-btn  contact-btn location-btn  mb-3"
                              >
                                <i className="fa-solid fa-location-dot"></i>{" "}
                                Locations
                              </Link>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      {loading && (
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <PageLoading color={"var(--metro-yellow)"} classes={"justify-content-center"} />
          </div>
        </div>
      )}
    </>
  );
};

export default BrowardCounty;
